export default "__VITE_ASSET__DXEti9Gi__"